(function() {
  'use strict';

  var pdfUrlEndpoints = {
    url: 'urlToPdf',
    html: 'htmlToPdf'
  };

  var MAX_PAYLOAD_SIZE = 5600000; // 5.6MB — raised from 4MB (SUP-0725).
  // This limits the size of the outgoing HTML payload sent to generate-pdf-serverless,
  // checked client-side in print-pdf.directive.js before the request is sent.
  // Hard ceiling is AWS Lambda's synchronous *request* payload limit: 6,291,456 bytes
  // (no base64 overhead applies here, since this is plain text HTML, not the binary
  // PDF response). 5.6MB leaves ~691KB margin below that limit.
  // Previous 4MB value had no documented rationale.
  var BASE_URL = 'https://pkg7axv4xl.execute-api.eu-west-2.amazonaws.com/dev/pdf';
  // var BASE_URL = 'http://localhost:3000/pdf';

  var apiUrls = {
    urlToPdf: BASE_URL + '/url',
    htmlToPdf: BASE_URL + '/html'
  };

  var defaults = {
    filename: 'Document.pdf',
    buttonTitle: 'Print PDF'
  };

  angular.module('blocks.pdf')
    .constant('PDF_MAX_PAYLOAD_SIZE', MAX_PAYLOAD_SIZE)
    .constant('PDF_DEFAULTS', defaults)
    .constant('PDF_URL_ENDPOINTS', pdfUrlEndpoints)
    .constant('PDF_API_URLS', apiUrls);
})();
